
import "../../styles/components/_breadcrumbs.scss";
import { waitForElements } from "../helpers/utils";
import { emitShopifyEvent } from "../services/analytics.service";

console.log("product template loaded");
waitForElements('.product__review-container > [data-bv-ready="true"]').then((els) => {
  console.log("product reviews loaded and visible");
  const loadedReviewsContainer = els[0];
  const observer = new IntersectionObserver((entries, observer) => {
    const entry = entries[0];
    if (entry.isIntersecting) {
      emitShopifyEvent("untuckit:product_reviews_viewed");
      observer.disconnect();
    }
  }, {
    threshold: [0.3]
  });
  observer.observe(loadedReviewsContainer);
});